


export const fetchpaths = {
  tb2: {
    dev: "http://localhost:3022/api",
    prod: "https://templatebuilder-docker.azurewebsites.net/api"
  },
  tb3: {
    dev: "http://localhost:3044/api",
    prod: "https://templatebuilder-docker.azurewebsites.net/api"
  },
}